export const colors = {
  cancelled: "#bebebe",
  confirmed: "linear-gradient(to right, #0575e6, #1F38A1)",
  confirmedArchived: "black",
  rental:
    "linear-gradient(90deg, rgba(3,162,28,1) 30%, rgba(0,54,9,1) 100%)",
};
